const tnmc = {
  init() {
    this.events();
  },

  events() {
    // Per page display.
    $(document).on("change", "#quantitySelect", function () {
      const value = $(this).val();
      if ("URLSearchParams" in window) {
        const searchParams = new URLSearchParams(window.location.search);
        searchParams.set("display", value);
        window.location.search = searchParams.toString();
      }
    });
  },
};
export default tnmc;
